import React, { useMemo } from 'react';
import {useDropzone} from 'react-dropzone';

const baseStyle = {
  flex: 1,
  width: 348,
  height: 169,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '56px 43px 49px 43px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#A5A3A3',
  borderStyle: 'dashed',
  backgroundColor: '#ffffff',
  color: '#000000',
  outline: 'none',
  transition: 'border .24s ease-in-out',
  marginBottom: 24
};

const acceptStyle = {
  borderColor: '#2196f3'
};

export default function StyledDropzone(props) {

  const {
    getRootProps,
    getInputProps,
    isDragAccept,
    open
  } = useDropzone({
    // Disable click and keydown behavior
    noClick: true,
    noKeyboard: true,
    onDrop: props.onGetFile,
    accept: '.csv'
  });

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isDragAccept ? acceptStyle : {}),
  }), [
    isDragAccept
  ]);

  return (
    <div className="container">
      <div {...getRootProps({
          style
        })}>
        <input {...getInputProps()} />
        <p>Arrastre el archivo aquí<br /><br/>o</p>
        <button 
          className="loader__button-loader black"
          onClick={open}
          >Seleccionar archivo</button>
      </div>
    </div>
  );
}